export const userConfig = {
  include: {
    position: {
      only: ['id', 'name']
    },
    department: {
      only: ['id', 'name']
    }
  }
}

export const managersConfig = {
  include: {
    position: {
      only: ['name']
    }
  }
}

export const usersListConfig = {
  order: [
    {
      last_name: 'asc'
    }
  ],
  include: {
    position: {
      only: ['name']
    },
    department: {
      only: ['name']
    }
  }
}
